<template>
  <div class="header_content">
    <div class="content_item_one">
      <div ref="echartMap" id="myChart"></div>
    </div>
    <div class="content_item_two">
      <!-- <div v-for="(item, index) in imgUrl" :key="index">
        <span>{{ item.title }}</span>
        <img :src="item.url" :alt="item.title" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "HaderContent",
  data() {
    return {
      cityData: null,
      city: null,
      index: 0,
      option: null,
      count: 0,
      num: 20,
      imgUrl: [
        // { title: "产品买家秀上传", url: require("@/assets/image/图标7.png") },
        // { title: "线上扫码结算", url: require("@/assets/image/图标8.png") },
        // { title: "产品详情浏览率", url: require("@/assets/image/图标9.png") },
      ],
    };
  },
  mounted() {
    let timer = setInterval(() => {
      if (this.$url.length > 0) {
        clearInterval(timer);
        this.$axios.get(`${this.$url}${this.$apiObj.mapApi}`).then((res) => {
          console.log(res.data.data)
          this.cityData = res.data.data.rows.sort((a, b) => {
            a[1] - b[1];
          });
          this.index = parseInt(this.cityData.length / 3);
          this.city = require("../../assets/city.js").default;

          let data = this.cityData.map((item) => {
            let obj = {};
            obj.name = item[0].replace("市", "");
            obj.value = parseInt(item[1]);
            return obj;
          });
          var geoCoordMap = this.city;
          this.option = {
            title: {
              text: "全国销量分布图",
              left: "center",
              subtext: "圆点的大小表示该地区销量的多少，圆点越大该地区销量越大",
              textStyle: {
                color: "white",
              },
            },

            tooltip: {
              trigger: "item",
            },
            geo: {
              map: "china",
              roam: true,
              label: {
                show: true,
                color: "rgba(211,211,211,0.4)",
              },
              itemStyle: {
                areaColor: "rgba(0 , 0 , 0 ,0)",
                borderColor: "rgba(255,255,255)",
              },
              emphasis: {
                itemStyle: {
                  areaColor: null,
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  shadowBlur: 20,
                  borderWidth: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },

            series: [
              {
                name: "销量",
                type: "effectScatter",
                coordinateSystem: "geo",
                data: this.convertData(data),
                symbolSize: (val, ele) => {
                  if (ele.dataIndex <= 49) {
                    // 前面 最大的
                    // return val[2] / this.num;
                    return this.num;
                  } else if (ele.dataIndex <= 49 * 2) {
                    // return val[2] / (this.num + 10000);
                    return this.num - 10;
                  } else {
                    return this.num - 20;
                    // return val[2] / (this.num + 20000);
                  }
                },
                encode: {
                  value: 2,
                },
                rippleEffect: {
                  brushType: "stroke",
                },
                label: {
                  formatter: "{b}",
                  position: "right",
                  show: false,
                },
                itemStyle: {
                  color: "pink",
                },
                emphasis: {
                  label: {
                    show: true,
                  },
                },
              },
            ],
          };

          this.echartsSetOption(this.option);
        });
      }
    }, 1000);

    // setInterval(() => {
    //   this.count++
    //   if(this.count % 2 === 0){
    //     this.num = 30 / 2
    //     this.option.series[0].itemStyle.color = 'pink'
    //   }else{
    //     this.num = 30
    //     this.option.series[0].itemStyle.color = 'pink'
    //   }
    //   this.echartsSetOption(this.option)
    // }, 4000);
  },
  methods: {
    echartsSetOption(option) {
      let myEcharts = this.$echarts.init(this.$refs.echartMap);
      this.randomValue();
      myEcharts.setOption(option);
    },
    randomValue() {
      return Math.round(Math.random() * 1000);
    },
    convertData(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var geoCoord = this.city[data[i].name];
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value),
          });
        }
      }
      return res;
    },
  },
};
</script>

<style lang="less">
.header_content {
  height: 100%;
  width: 100%;
  .content_item_one {
    position: relative;
    height: 70%;
    width: 100%;
    // background: url("~@/assets/image/线框3.png") no-repeat;
    background-size: 100% 100%;
    #myChart {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 100%;
      height: 100%;
      z-index: 999;
    }
  }
  .content_item_two {
    display: flex;
    justify-content: space-around;
    height: 28%;
    width: 100%;
    margin-top: 1.25rem;
    z-index: 999;
    position: relative;
    text-align: center;
    div {
      display: flex;
      justify-content: space-around;
      flex-direction: column;
      span {
        color: white;
        font-size: 1.25rem;
      }
    }
  }
}
</style>